import { AlertTriangle } from "lucide-react";
import React from "react";

import { useConnection } from "@/auth/ConnectionContext";
import { authModeLabel } from "@/auth/sso-messages";
import { extractErrorMessage } from "@/lib/api-errors";
import { ssoConnectionProblem, useOneCBases } from "@/lib/use-onec-bases";

/** Режим входа текущей сессии — плашкой у логина в сайдбаре. Видно всегда:
 *  от режима зависит, как портал ходит в 1С (логин/пароль подключения или JWT
 *  SSO). В SSO — ещё значок, если активное подключение в SSO не заработает. */
export function AuthModeBadge({ mode }: { mode: string | undefined }): React.ReactElement {
  return (
    <span
      data-testid="auth-mode"
      className="inline-flex shrink-0 items-center gap-0.5 rounded bg-muted px-1 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground"
    >
      {authModeLabel(mode)}
      {mode === "sso" && <SsoProblemMark />}
    </span>
  );
}

function SsoProblemMark(): React.ReactElement | null {
  const { data, error } = useOneCBases();
  const { activeConnection } = useConnection();
  const problem = error
    ? `Справочник баз 1С не загрузился: ${extractErrorMessage(error, "нет ответа")}`
    : data && activeConnection
      ? ssoConnectionProblem(activeConnection, data)
      : null;
  if (problem === null) return null;
  return (
    <span title={problem} className="inline-flex">
      <AlertTriangle className="size-3 text-amber-600" aria-label={problem} />
    </span>
  );
}
